import Http from "../../http/client";

export default async () => {
    const response = await Http.get(`admin/specialdays`);
    return response.data;
}
